import { colors, Td, Tr } from "@biblioteksentralen/react";
import { OpeningHoursDay, SelfServiceOpeningHoursDay } from "@libry-content/types";
import { ReactNode } from "react";

import { TimeSpans } from "../TimeSpan";

export const getVerticalTableCellPadding = (level: number) => `${0.75 + 0.5 * level}rem`;

type TableDataProps = { children: ReactNode; oddTableItem?: boolean; level: number };

const TableData = ({ children, oddTableItem, level }: TableDataProps) => (
  <Td
    border="none"
    padding={`0.5rem ${getVerticalTableCellPadding(level)} !important`}
    background={oddTableItem ? colors.grey05 : undefined}
  >
    {children}
  </Td>
);
type SpecialOpeningHoursDayProps = {
  label: ReactNode;
  hasSelfService: boolean;
  normalHoursDay?: OpeningHoursDay;
  selfServiceHoursDay?: SelfServiceOpeningHoursDay;
  oddTableItem?: boolean;
  level?: number;
};

const SpecialOpeningHoursDay = ({
  label,
  normalHoursDay,
  selfServiceHoursDay,
  hasSelfService,
  oddTableItem,
  level = 0,
}: SpecialOpeningHoursDayProps) => (
  <Tr>
    <TableData level={level} oddTableItem={oddTableItem}>
      {label}
    </TableData>
    <TableData level={level} oddTableItem={oddTableItem}>
      {normalHoursDay?.closed ? "Stengt" : <TimeSpans spans={normalHoursDay?.spans} />}
    </TableData>
    {hasSelfService && (
      <TableData level={level} oddTableItem={oddTableItem}>
        {!selfServiceHoursDay?.enabled ? "Stengt" : <TimeSpans spans={selfServiceHoursDay?.spans} />}
      </TableData>
    )}
  </Tr>
);

export default SpecialOpeningHoursDay;
